import { config } from '../config';
import { authService } from './auth';

export interface ScriptMetadata {
  title: string;
  description: string;
  image_prompt: string;
  tags: string[];
}

export interface GenerateMetadataRequest {
  scriptText: string;
}

class MetadataService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = config.apiUrl || 'http://localhost:3001';
  }

  /**
   * Generate metadata for a meditation script
   */
  async generateMetadata(scriptText: string): Promise<ScriptMetadata> {
    const token = authService.getToken();
    
    if (!token) {
      throw new Error('Authentication required');
    }

    if (!scriptText || scriptText.trim().length < 50) {
      throw new Error('Script text must be at least 50 characters long');
    }

    try {
      console.log('Generating script metadata...', { textLength: scriptText.length });
      
      const response = await fetch(`${this.baseUrl}/analyze-script-metadata`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ scriptText }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
      }

      const metadata = await response.json();
      console.log('Script metadata generated successfully:', metadata);
      
      return metadata;
    } catch (error) {
      console.error('Error generating script metadata:', error);
      throw error;
    }
  }
}

export const metadataService = new MetadataService();